/**
 * Route for `kyc-aml`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KycAmlPage } from "../features/kyc-aml/KycAmlPage";

export const kycAmlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kyc-aml",
	component: KycAmlPage,
});

export default kycAmlRoute;
